

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-100 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl p-8">

        <h1 className="text-3xl font-bold text-center text-blue-900 mb-4">
          Privacy Policy
        </h1>

        <p className="text-center text-gray-500 mb-8">
          <strong>Last Updated:</strong> March 2026
        </p>

        <p className="text-gray-700 mb-6">
          Welcome to <strong>Online Quran and Islamic Institute</strong>. We are committed to
          protecting your personal information and your right to privacy. Our
          physical office is located in <strong>Shamsabad, Rawalpindi</strong>,
          and we provide educational services remotely to students worldwide.
        </p>

        {/* Section 1 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
          1. Information We Collect
        </h2>

        <p className="text-gray-700 mb-3">
          We collect personal information that you voluntarily provide when
          registering for classes or contacting us.
        </p>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            <strong>Student & Parent Details:</strong> Name, email address,
            phone/WhatsApp number, and country of residence.
          </li>
          <li>
            <strong>Educational Data:</strong> Student age (for level
            placement), attendance records, and progress reports.
          </li>
          <li>
            <strong>Payment Data:</strong> Information necessary to process
            tuition fees such as bank transfer details or billing address. We
            do not store full credit card numbers.
          </li>
        </ul>

        {/* Section 2 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          2. How We Use Your Information
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>To provide and manage your online Quranic classes.</li>
          <li>To communicate class schedules, updates, and progress reports.</li>
          <li>To process payments and provide receipts.</li>
          <li>To improve our teaching methods and website services.</li>
        </ul>

        {/* Section 3 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          3. Remote Learning & Recordings
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            Classes are conducted via third-party platforms such as Zoom,
            Skype, or Google Meet.
          </li>
          <li>
            <strong>Class Recordings:</strong> Sessions may be recorded for
            teacher training or student revision purposes. Recordings are
            stored securely and not shared with unauthorized parties.
          </li>
        </ul>

        {/* Section 4 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          4. Children’s Privacy
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            We collect data from children under 18 only with consent from a
            parent or guardian.
          </li>
          <li>
            Parents may review, edit, or request deletion of their child’s
            information at any time.
          </li>
        </ul>

        {/* Section 5 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          5. Data Sharing
        </h2>

        <p className="text-gray-700 mb-3">
          We do not sell personal data. Information may only be shared with:
        </p>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            <strong>Service Providers:</strong> Video conferencing and payment
            processing platforms.
          </li>
          <li>
            <strong>Legal Requirements:</strong> If required under Pakistani law
            (PECA) or to protect our legal rights.
          </li>
        </ul>

        {/* Section 6 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          6. Security of Your Data
        </h2>

        <p className="text-gray-700">
          We implement administrative and technical security measures including
          SSL encryption to protect your data. However, no method of internet
          transmission is 100% secure.
        </p>

        {/* Section 7 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          7. Your Rights
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Request a copy of the data we hold about you.</li>
          <li>Request correction of inaccurate information.</li>
          <li>Request deletion of your data if you withdraw from our courses.</li>
        </ul>

        {/* Section 8 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          8. Contact Us
        </h2>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-gray-700">
          <p>
            If you have questions about this Privacy Policy, please contact us:
          </p>

          <p className="mt-2">
            <strong>Email:</strong> ceo@onlinequranandislamicinstitue.com
          </p>

          <p>
            <strong>WhatsApp/Phone:</strong> +92 339 155 2155
          </p>

          <p>
            <strong>Address:</strong> 3rd floor, kiyani plaza murree road, Shamsabad,
            Rawalpindi, Pakistan
          </p>
        </div>

        <p className="text-center text-gray-400 mt-10 text-sm">
          © 2026 Online Quran and Islamic Institute — All Rights Reserved
        </p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;